var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFermier({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.899,
    height: 98.37,
    viewBox: "0 0 86.899 98.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13962",
    "data-name": "Group 13962",
    transform: "translate(94.943 116.588)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2516",
    "data-name": "Path 2516",
    d: "M-17.825-116.552a19.017,19.017,0,0,1,5.067.754,11.271,11.271,0,0,0,6.6.016,22.043,22.043,0,0,1,5.064-.78,4.314,4.314,0,0,1,3.912,1.934,22.346,22.346,0,0,1,3.4,8.416c.382,1.589.663,3.208.888,4.827a1.22,1.22,0,0,0,1,1.207A61.93,61.93,0,0,1,18.9-95.994a14.568,14.568,0,0,1,3.3,2.265,3.618,3.618,0,0,1,1.3,3.068c-.111,1.21-.4,1.593-1.6,1.415C19.835-89.553,17.8-90,15.75-90.378A145.851,145.851,0,0,0-11.3-92.4,134.44,134.44,0,0,0-40.915-89.36c-.72.166-1.665.539-2.191-.221a2.731,2.731,0,0,1-.027-2.779A6.778,6.778,0,0,1-40.463-95a45.226,45.226,0,0,1,11.787-4.928A2.543,2.543,0,0,0-26.6-102.3a34.911,34.911,0,0,1,3.347-10.123,12.922,12.922,0,0,1,1.482-2.225A4.319,4.319,0,0,1-17.825-116.552Z",
    transform: "translate(-36.064 0)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2517",
    "data-name": "Path 2517",
    d: "M25.864-2.282a18.859,18.859,0,0,1-18.823-19.5c.032-.912.306-1.255,1.256-1.342A183.29,183.29,0,0,1,38.1-23.472c1.857.134,3.706.372,5.563.485.7.043.93.25.966.971A18.788,18.788,0,0,1,25.864-2.282Z",
    transform: "translate(-71.486 -64.964)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2518",
    "data-name": "Path 2518",
    d: "M-85.863,43.807c0-6.15-.03-12.3.027-18.449.01-1.132-.229-1.594-1.434-1.454a7.007,7.007,0,0,1-3.089-.319,6.647,6.647,0,0,1-4.56-6.257c-.042-4.919-.021-9.84-.014-14.759,0-1.276.645-2.047,1.681-2.085,1.066-.039,1.809.77,1.813,2.087q.026,7.044,0,14.088a3.412,3.412,0,0,0,1.923,3.477c.731.349,1.042.292,1.036-.653-.035-5.4-.017-10.808-.016-16.213,0-.373-.014-.747.022-1.117A1.739,1.739,0,0,1-86.718.479a1.743,1.743,0,0,1,1.7,1.724c.026.334.013.671.013,1.006,0,5.442.014,10.884-.016,16.325,0,.726.179.954.926.953,2.226,0,2.226.029,2.226-2.2q0-7.6,0-15.207a6.043,6.043,0,0,1,.057-1.112A1.708,1.708,0,0,1-79.984.5a1.7,1.7,0,0,1,1.641,1.669c.025.3.01.6.01.894,0,5.479.022,10.958-.021,16.436-.007.906.329.984,1.035.789a3.322,3.322,0,0,0,2.328-3.418q.014-6.877,0-13.753c0-.3-.016-.6.007-.894A1.747,1.747,0,0,1-73.274.491,1.729,1.729,0,0,1-71.487,2.02a5.252,5.252,0,0,1,.039,1q0,6.765,0,13.529c0,4.607-2.768,7.388-7.344,7.4-2.313.006-2.313.006-2.313,2.322q0,18.114.019,36.228c0,.919-.118,1.382-1.182,1.237-1.163-.158-2.745.492-3.407-.261-.581-.66-.183-2.2-.184-3.347Q-85.87,51.969-85.863,43.807Z",
    transform: "translate(0 -82.068)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M37.588,84.817c-3.65,0-7.3-.031-10.951.024-.831.013-1.077-.246-1.153-1.028q-.825-8.5-1.735-17c-.077-.709.336-.724.74-.824a54.415,54.415,0,0,1,14.816-1.669A53.5,53.5,0,0,1,50.445,65.9c.764.189,1.022.433.933,1.246q-.929,8.491-1.758,16.993c-.074.758-.48.683-.97.682Q43.12,84.814,37.588,84.817Z",
    transform: "translate(-83.201 -126.809)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M131.568,76.524a46.089,46.089,0,0,1,14.106,7.523,9.529,9.529,0,0,1,3.844,7.816c.013,5.884-.01,11.768.022,17.652,0,.744-.213.918-.93.912q-6.424-.049-12.849,0c-.711.005-.953-.214-1.043-.918-.58-4.538-1.206-9.07-1.82-13.6a2.445,2.445,0,0,0-2.474-2.5c-.369-.054-.628-.042-.573-.553C130.43,87.45,130.99,82.049,131.568,76.524Z",
    transform: "translate(-157.584 -135.379)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M-40.912,97.419c0-4.136.011-8.273-.013-12.409a1.4,1.4,0,0,1,.691-1.356A65.21,65.21,0,0,1-28.3,77.422c.879-.349.981-.141,1.063.71.468,4.893,1,9.78,1.534,14.666.079.718.062,1.117-.869,1.182-1.236.086-1.867.908-2.057,2.261-.645,4.608-1.3,9.213-1.921,13.825-.083.615-.209.894-.923.882q-4.3-.071-8.609,0c-.724.011-.848-.237-.843-.893C-40.9,105.841-40.912,101.63-40.912,97.419Z",
    transform: "translate(-37.868 -135.895)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M18.715,141.261A1.825,1.825,0,0,1,16.8,142.9a1.789,1.789,0,0,1-1.6-1.938,1.761,1.761,0,0,1,1.952-1.567A1.8,1.8,0,0,1,18.715,141.261Z",
    transform: "translate(-77.209 -179.448)",
    fill: "#ffbe00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M116.882,141.094a1.821,1.821,0,0,1-1.736,1.826,1.844,1.844,0,0,1-1.795-1.662,1.8,1.8,0,0,1,1.689-1.858A1.762,1.762,0,0,1,116.882,141.094Z",
    transform: "translate(-146.019 -179.455)",
    fill: "#ffbe00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFermier);
export default __webpack_public_path__ + "static/media/fermier.1c5e50352da32e9fc2d81bad7ffaba2c.svg";
export { ForwardRef as ReactComponent };